import { Text } from '@atoms/index';
import Button from '@ui/atoms/design-system/Button';
import texts from '@components/ReferAndEarn/en.json';
import { useContext, useState } from 'react';
import AuthContext from '@context/auth';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { referAndEarnGaEventsName } from '@helpers/ga-events-name-enum';

const ReferralInfo = ({
    referralLink = null,
    buttonType = 'primary',
    buttonText = texts?.StartEarningRewards,
    position = 'justify-center',
}) => {
    const [isCopied, setIsCopied] = useState(false);
    const { signUpModal } = useContext(AuthContext);

    const handleSignupModal = () => {
        triggerCustomGaEvent(referAndEarnGaEventsName.CLICKED_SIGNUP_TO_EARN_REWARD)
        signUpModal();
    };

    const refferLinkcopy = async () => {
        if (!isCopied) {
            triggerCustomGaEvent(referAndEarnGaEventsName.CLICKED_COPY_REFERRAL_LINK)
            await navigator.clipboard.writeText(referralLink);
            setIsCopied(true);

            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        }
    };

    return referralLink ? (
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg">
            <div className="flex flex-col gap-1">
                <Text
                    content={texts?.YourReferralLink}
                    className="p5-medium md:p4-medium text-gray-500"
                />
                <Text
                    content={referralLink}
                    className="p5-regular md:p3-regular text-primary-500"
                />
            </div>
            <Button
                onClick={refferLinkcopy}
                buttonType={isCopied ? 'primary' : 'secondary'}
                buttonSize="small"
                buttonText={isCopied ? texts?.Copied : texts?.CopyLink}
                className={`border-[1.5px] ${
                    isCopied ? '!cursor-default' : ''
                }`}
                widthClass="w-full md:w-[103px]"
            />
        </div>
    ) : (
        <div className={`flex ${position}`}>
            <Button
                onClick={handleSignupModal}
                buttonSize="small"
                buttonType={buttonType}
                buttonText={buttonText}
                widthClass="w-full md:w-min"
            />
        </div>
    );
};

export default ReferralInfo;
